import { Environments } from "../../js/config/env-endpoints";

export enum EventType {
  CLICK = "click",
  CHANGE = "change",
  FOCUSOUT = "focusout",
  KEYUP = "keyup",
}
export interface SurveyStep {
  name: string;
  question?: string;
  url?: string;
  children?: SurveyStep[];
  type?: StepType;
  condition?: boolean;
  idMestiere?: string;
}

export enum StepType {
  ANSWERS = "answers",
  ZIPCODE = "cap",
  SUPPORT = "support"
}
export interface SurveyRedirect {
  name: string;
  url: string;
}
export interface SurveyBreadCrumb {
  question?: string;
  name: string;
  lastAnswer?: string;
}

export interface SurveyAnswer {
  domanda: string;
  risposta: string;
}
export interface SurveyState {
  paths: SurveyBreadCrumb[];
  currentStep?: SurveyBreadCrumb;
  rootAnswer?: string;
  forward?: boolean;
  insertedCap?: string;
}
export interface ListenerRecord {
  handler: (event?: Event) => void;
  eventType: EventType | Array<EventType>;
}
export interface ActionListeners extends Map<HTMLElement, ListenerRecord> { }
export interface BaseUtag {
  virtual: string;
}
export interface UtagModuloProfiloUtente {
  user_email: string //hash md5
  user_type?: "pf" | "pg" | "" //persona fisica o giuridica
  user_crm_id: string;
  user_hash_cf: string; //hash md5
  
  user_phone_number: string;
  //email: string //hash md5
}

export interface UtagModuloInformazioni {
  page_environment: string;
  page_id: string;
  page_name: string;
  page_breadcrumbs: string;
  page_url: string;
  referring_url: string;
  previous_pagename: string;
  login_status: "logged" | "not logged";
  product_category?: string;
  
}

export interface UtagModuloCap {
  cap: string;
}
export interface UtagModuloAction {
  action_name: string;
  action_tech: string;
  action_type: string;
  action_effect: string;
  action_element_position: string;
  action_element_type: string;
}
export enum SurveySupportType {
  Tel = 'survey-support-tel',
  Chat = 'survey-support-chat',
  WriteUs = 'survey-support-writeus'
}
export const AnalyticsSupportTypeName: Map<SurveySupportType, string> = new Map<SurveySupportType, string>([
  [SurveySupportType.Tel, 'chiamaci al numero verde'],
  [SurveySupportType.Chat, 'chatta con noi'],
  [SurveySupportType.WriteUs, 'scrivici e ti ricontattiamo']
]);